<template>
  <div class="account-controls">
    <PageSwitch />
    <NotificationsMenu />
    <FavoritesMenu />
    <CollectionsMenu />
    <ProfileMenu :user-data="userData" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

import { GetUserData } from '~/constants/getters';

import ProfileMenu from '~/components/account/ProfileMenu';
import FavoritesMenu from '~/components/account/FavoritesMenu';
import NotificationsMenu from '~/components/account/NotificationsMenu';
import CollectionsMenu from '~/components/account/CollectionsMenu';
import PageSwitch from '~/components/common/PageSwitch';

export default {
  name: 'AccountControls',
  components: {
    PageSwitch,
    CollectionsMenu,
    NotificationsMenu,
    FavoritesMenu,
    ProfileMenu,
  },

  setup() {
    const store = useStore();
    const userData = computed(() => store.getters[`authStore/${GetUserData}`]);

    return {
      userData,
    };
  },
};
</script>

<style scoped lang="scss">
.account-controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: $bb-spacing-2;
  gap: $bb-spacing-2;
}

.notification {
  margin-right: $bb-spacing-5;
}
</style>
